/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {TemplatesContent} from './TemplatesContent';

/**
 * The TemplatesBody model module.
 * @module model/TemplatesBody
 * @version 1.0.0
 */
export class TemplatesBody {
  /**
   * Constructs a new <code>TemplatesBody</code>.
   * @alias module:model/TemplatesBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TemplatesBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TemplatesBody} obj Optional instance to populate.
   * @return {module:model/TemplatesBody} The populated <code>TemplatesBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TemplatesBody();
      if (data.hasOwnProperty('propertyId'))
        obj.propertyId = ApiClient.convertToType(data['propertyId'], 'String');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('content'))
        obj.content = TemplatesContent.constructFromObject(data['content']);
    }
    return obj;
  }
}

/**
 * @member {String} propertyId
 */
TemplatesBody.prototype.propertyId = undefined;

/**
 * @member {String} title
 */
TemplatesBody.prototype.title = undefined;

/**
 * @member {String} description
 */
TemplatesBody.prototype.description = undefined;

/**
 * @member {module:model/TemplatesContent} content
 */
TemplatesBody.prototype.content = undefined;

